import React, { Component } from 'react';
// import {arrayOf, number, bool, string, func, object} from 'prop-types';
// import { Link } from 'react-router-dom';
import Aux from '../Hoc/Aux';
// import usnews from '../../assets/cdphp-usnews-medicare-2025.svg';
// import medicareRating from '../../assets/svg/icon-medicare-rating.svg';
// import medicareRatingPPO from '../../assets/svg/icon-medicare-ppo.svg';
// import medicareRatingHMO from '../../assets/svg/icon-medicare-hmo.svg';
// import medicareRatingDual from '../../assets/svg/icon-medicare-dual-2022.svg';
import jdPowerRating from '../../assets/jdpower-rating-07.png';
import ncqaRating from '../../assets/ncqa-health-plan-accredited.jpg';

class Ratings extends Component {
  render () {
    const medicareIcon = {
      width: '250px'
    };
    // const usnewsIcon = {
    //   width: '122px'
    // };

    let ratings = null;

    if (this.props.medicare === 'true') {
      // NCQA-only for Medicare. Leave unrendered rather than an empty divider.
      // Restore star / U.S. News columns here when those assets are in use again:
      // <div className='col'>
      //   <a href='https://www.cdphp.com/-/media/files/medicare/medicare2026/members/medicare-star-rating-ppo-hmo.pdf' target='_blank' rel='noopener noreferrer'>
      //     <span><img src={medicareRating} alt='4.5 out of 5 Medicare Ranking' style={medicareIcon} /></span>
      //     <p>Every year, Medicare evaluates plans based on a 5-star rating system.<sup>&dagger;</sup></p>
      //   </a>
      // </div>
      // <div className='col'>
      //   <a href='https://health.usnews.com/medicare/cdphp-medicare-advantage-medicare-plans-in-new-york' target='_blank' rel='noopener noreferrer'>
      //     <span><img src={usnews} alt='Best Insurance Company for Medicare Advantage 2025 by U.S. News' style={usnewsIcon} /></span>
      //     <p>Named a Best Insurance Company &ndash; Medicare Advantage 2025 in New York by U.S. News &amp; World&nbsp;Report.</p>
      //   </a>
      // </div>
    } else if (this.props.government === 'true') {
      // NCQA-only. Leave unrendered rather than an empty divider.
      // <div className='col'>
      //   <span><img src={jdPowerRating} alt='8 out of 9 years' style={medicareIcon} /></span>
      //   <p>#1 in Member Satisfaction among Commercial Health Plans in New York, eight out of nine years.**</p>
      // </div>
    } else if (this.props.homepage === 'true') {
      ratings = (<Aux>
        <div className='col'>
          <span><img src={jdPowerRating} alt='9 out of 10 years' style={medicareIcon} /></span>
          <p>#1 in Member Satisfaction among Commercial Health Plans in New York, nine out of ten years.**</p>
        </div>
        {/* <div className='col'>
          <a href='https://www.cdphp.com/-/media/files/medicare/medicare2026/members/medicare-star-rating-ppo-hmo.pdf' target='_blank' rel='noopener noreferrer'>
            <span><img src={medicareRating} alt='4.5 out of 5 Medicare Ranking' style={medicareIcon} /></span>
            <p>Every year, Medicare evaluates plans based on a 5-star rating system.<sup>&dagger;</sup></p>
          </a>
        </div> */}
      </Aux>);
    } else if (this.props.medicaid === 'true') {
      // NCQA-only. Leave unrendered rather than an empty divider.
      // <div className='col w50'>
      //   <span><img src={jdPowerRating} alt='8 out of 9 years' style={medicareIcon} /></span>
      //   <p>#1 in Member Satisfaction among Commercial Health Plans in New York, eight out of nine years.**</p>
      // </div>
    } else if (this.props.smallbiz === 'true') {
      ratings = (<Aux>
        <div className='col w50'>
          <span><img src={ncqaRating} alt='NCQA Accredited Health Plan' /></span>
          <p>HMO plans rated 5 out of 5 stars and PPO plans rated 4.5 out of 5 stars, collectively among the highest-rated plans in the&nbsp;nation.*</p>
        </div>
        <div className='col w50'>
          <span><img src={jdPowerRating} alt='9 out of 10 years' style={medicareIcon} /></span>
          <p>CDPHP has been ranked <strong>#1 in Member Satisfaction among Commercial Health Plans in New York</strong> for nine of ten years.**</p>
        </div>
      </Aux>);
    }

    if (!ratings) {
      return null;
    }

    return (
      <section className='divide p60'>
        <div className='wrap three-col ratings'>

          {ratings}

        </div>
      </section>
    );
  }
}

Ratings.propTypes = { // validate props expected
};

export default Ratings;
